import { IEvent } from "@spawn/core";

export enum GameEvents {
	SetMultiplier = "nrg_setNotchMultiplier",
	StartConsecutiveNudgeUps = "nrg_startConsecutiveNudgeUps",
	UpdateFullReelset = "nrg_updateFullReelset",
}

export interface SetMultiplierEvent extends IEvent {
	type: GameEvents.SetMultiplier;
	payload: {
		multiplier: number;
	};
}

export interface StartConsecutiveNudgeUpsEvent extends IEvent {
	type: GameEvents.StartConsecutiveNudgeUps;
	payload: {
		nudgeCount: number;
	};
}

/**
 * Updates the full reelset (visible and offscreen symbols) to the given reels.
 */
export interface UpdateFullReelsetEvent extends IEvent {
	type: GameEvents.UpdateFullReelset;
	payload: {
		reels: string[][];
	};
}
